// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart3_first__3jHH_","second":"Chart3_second__1jcFg","third":"Chart3_third__dbPPz","four":"Chart3_four__nZ71Q","five":"Chart3_five__3McDo"};